import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'brastrap/common/icon/Icon';

const ShowMoreButton = ({ onToggleButton, showMoreLabel, isFilterButton }) => {
  return (
    <button className="c-show-more-button" onClick={() => onToggleButton()}>
      {isFilterButton && (
        <div className="c-filter-icon">{<Icon icon="filter" />}</div>
      )}
      <span className="c--show-more-button_label">{showMoreLabel}</span>
    </button>
  );
};

ShowMoreButton.propTypes = {
  onToggleButton: PropTypes.func,
  showMoreLabel: PropTypes.boolean,
  isFilterButton: PropTypes.boolean,
};

ShowMoreButton.defaultProps = {
  showMore: false,
  onToggleButton: () => {},
  showMoreLabel: false,
  isFilterButton: false,
};

export default ShowMoreButton;
